import { render, staticRenderFns } from "./SitesCreate.vue?vue&type=template&id=72354916&"
import script from "./SitesCreate.vue?vue&type=script&lang=js&"
export * from "./SitesCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72354916')) {
      api.createRecord('72354916', component.options)
    } else {
      api.reload('72354916', component.options)
    }
    module.hot.accept("./SitesCreate.vue?vue&type=template&id=72354916&", function () {
      api.rerender('72354916', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/sites/SitesCreate.vue"
export default component.exports